module.exports = __webpack_public_path__ + "static/media/padlock.8a2edcc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/padlock.svg
// module id = 724
// module chunks = 0